export default __webpack_public_path__ + "static/media/white_A.7537ecae.svg";